import { UserListTypes as DirectoryUserQuery } from "api/PowerUserHelpers";

interface UserDirectoryState {
  username: string;
  page: number;
  pageSize: number;
  refresh?: boolean;
  sortBy?: string;
  sortOrder?: string;
  filterColumn?: string;
  filterType?: string;
  filterValue?: unknown;
}

export const buildUserDirectoryQuery = ({
  username,
  page,
  pageSize,
  refresh,
  sortBy,
  sortOrder,
  filterColumn,
  filterType,
  filterValue,
}: UserDirectoryState): DirectoryUserQuery => ({
  username,
  rolename: "",
  page,
  pageSize,
  refresh: refresh || undefined,
  sortBy: sortBy || undefined,
  sortOrder: sortOrder || undefined,
  filterColumn: filterColumn || undefined,
  filterType: filterType || undefined,
  filterValue: filterColumn ? filterValue : undefined,
});
